import {SelectItemS} from "@app/core/components/select/Item.type";

export const buyStatusOptions: SelectItemS = [
  {value: "", key: "all"},
  {value: "true", key: "خرید کرد"},
  {value: "false", key: "خرید نکرد"},
];

export const answeredStatusOptions: SelectItemS = [
  {value: "", key: "all"},
  {value: "true", key: "جواب داد"},
  {value: "false", key: "جواب نداد"},
];

export const didWeContactOptions: SelectItemS = [
  {value: "", key: "هر دو"},
  {value: "true", key: "ما"},
  {value: "false", key: "مشتری"},
];

export const purchaseTypeOptions: SelectItemS = [
  {value: "", key: "all"},
  {value: "true", key: "حضوری"},
  {value: "false", key: "غیرحضوری"},
];

export const customerStatusOptions: SelectItemS = [
  {value: "", key: "all"},
  {value: "true", key: "مشتری جدید"},
  {value: "false", key: "مشتری قدیمی"},
];

export const archivedOptions: SelectItemS = [
  {value: "", key: "آرشیو نشده"},
  {value: "true", key: "آرشیو شده"},
];
